import { toast as _toast, type ToastOptions } from "react-hot-toast";

type ToastVariant = "success" | "error" | "warning" | "info";

declare module "react-hot-toast" {
  interface Toast {
    variant?: ToastVariant;
  }
}

type ExtendedToastOptions = ToastOptions & { variant?: ToastVariant };

type MessageArg = string;

function warning(message: MessageArg, options?: ToastOptions) {
  const opts: ExtendedToastOptions = {
    ...options,
    icon: undefined,
    variant: "warning",
  };
  return _toast(message, opts as ToastOptions);
}

function info(message: MessageArg, options?: ToastOptions) {
  const opts: ExtendedToastOptions = {
    ...options,
    icon: undefined,
    variant: "info",
  };
  return _toast(message, opts as ToastOptions);
}

export const toast = Object.assign(
  (message: MessageArg, options?: ToastOptions) => _toast(message, options),
  {
    success: (message: MessageArg, options?: ToastOptions) =>
      _toast.success(message, options),
    error: (message: MessageArg, options?: ToastOptions) =>
      _toast.error(message, options),
    warning,
    info,
    loading: (message: MessageArg, options?: ToastOptions) =>
      _toast.loading(message, options),
    dismiss: _toast.dismiss,
    remove: _toast.remove,
    promise: _toast.promise,
  },
);
